




























import { Component, Prop, Vue } from "vue-property-decorator";
import CreateSessionResultModel from "@/models/security/zorgID/createSessionResultModel";
import InitializeSessionComponent from "@/components/zorgID/InitializeSessionComponent.vue";
import OpenSessionComponent from "@/components/zorgID/OpenSessionComponent.vue";

@Component({
  components: {
    InitializeSessionComponent,
    OpenSessionComponent,
  },
})
export default class LogonDebug extends Vue {
  public $refs!: Vue["$refs"] & {
    initializeSessionComponent: InitializeSessionComponent;
    openSessionComponent: OpenSessionComponent;
  };

  private readonly STATE_START: number = 0;
  private readonly SESSION_INITIALIZED: number = 1;
  private readonly SESSION_OPENED: number = 2;

  private state: number = this.STATE_START;

  private btnInitializeSessionEnabled: boolean = true;

  // #region SessionInitialize

  private initializeSession() {
    var me = this;
    me.btnInitializeSessionEnabled = false;
    me.state = me.SESSION_INITIALIZED;
    this.$refs.initializeSessionComponent.initializeSession();
  }

  private sessionInitialized(model: CreateSessionResultModel) {
    var me = this;
    me.state = me.SESSION_OPENED;
    this.$refs.openSessionComponent.openSession(model);
  }

  // #endregion

  // #region checkOpenedSessionStatus

  private btnLogoutEnabled: boolean = false;

  private sessionOpened() {
    var me = this;
  }

  // #endregion
}
